import React, { useState, useEffect } from "react";
import "./favoritesProperties.css";
import AllProperties from "../AllProperties/AllProperties";
import { listFavorites } from "../../../services/api/user_favorites";

export default function FavoritesProperties() {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchProperties() {
      setLoading(true);
      try {
        const { favorites } = await listFavorites();
        // Garante que 'favorites' seja um array para evitar erros
        setProperties(favorites || []);
      } catch (error) {
        console.error("Erro ao buscar propriedades favoritas:", error);
        setProperties([]);
      } finally {
        setLoading(false);
      }
    }

    fetchProperties();
  }, []);

  if (loading) {
    return (
      <section>
        <h1 className="page-title">MEUS FAVORITOS</h1>
        <div
          className="loading-message"
          style={{ textAlign: "center", padding: "40px" }}
        >
          <p>Carregando seus imóveis favoritos...</p>
        </div>
      </section>
    );
  }

  return (
    <section>
      <h1 className="page-title">MEUS FAVORITOS</h1>
      {properties.length > 0 ? (
        <AllProperties
          especific_database={properties} // Passa a lista de imóveis favoritos
          favorites={properties} // Passa a mesma lista para os IDs de favoritos
          undefined_mensage="Você ainda não favoritou nenhum imóvel"
          title_visible={false}
          filters_visible={true}
          // Note que não passamos `realEstateNameById`. O AllProperties vai buscar isso.
        />
      ) : (
        <div className="undefined-mensage" style={{ paddingTop: "40px" }}>
          <p>Você ainda não favoritou nenhum imóvel.</p>
        </div>
      )}
    </section>
  );
}
